import { render, staticRenderFns } from "./IndexPageEspeciallyRecommendSection.vue?vue&type=template&id=1cb5fa89&"
import script from "./IndexPageEspeciallyRecommendSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageEspeciallyRecommendSection.vue?vue&type=script&lang=js&"
import style0 from "./IndexPageEspeciallyRecommendSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports